import commonService from "@/services/common.service"
import { ActionContext } from "vuex"
import { arr2map } from "@/utils"

interface StateItem {
    value: number | string
    label: string
}
interface VisibleProducts {
    product_id: number
    product_name: string
    product_sub_type: number
    product_type: number
    software_id: number
    dept: number
}
export interface State {
    // 系统版本号
    version: string
    // 开展业务区域
    business_area: StateItem[]
    // 法人公司
    corporation: StateItem[]
    //已有产品
    software_list: StateItem[]
    // 产品类型-树
    product_type_tree: StateItem[]
    // 产品类型
    product_type: StateItem[]
    // 二级产品类型（平台）
    product_sub_type: StateItem[]
    // 事业部
    top_dept: StateItem[]
    // 版本类型
    version_type: StateItem[]
    // 操作记录类型翻译
    operate_records: StateItem[]
    // 渠道
    channel: StateItem[]
    // 隐私政策区域
    area: StateItem[]
    // 编制状态
    preparation_status: StateItem[]
    // 隐私政策状态枚举
    privacy_policy_status: StateItem[]
    // 隐私政策同步方式
    privacy_policy_sync_way: StateItem[]
    // 隐私政策文本类型
    privacy_policy_text_type: StateItem[]
    // AIGC产品名称
    visible_products: VisibleProducts[]
}

const state: State = {
    version: "",
    business_area: [],
    corporation: [],
    software_list: [],
    product_type_tree: [],
    product_type: [],
    product_sub_type: [],
    top_dept: [],
    version_type: [],
    operate_records: [],
    channel: [],
    area: [],
    preparation_status: [],
    privacy_policy_status: [],
    privacy_policy_sync_way: [],
    privacy_policy_text_type: [],
    visible_products: []
}

const mutations = {
    setEnums: (state: State, payload: any) => {
        const {
            business_area,
            corporation,
            top_dept,
            product_type_tree,
            product_type,
            product_sub_type,
            software_list,
            version_type,
            operate_records,
            channel,
            area,
            preparation_status,
            privacy_policy_status,
            privacy_policy_sync_way,
            privacy_policy_text_type,
            visible_products
        } = payload
        const formattedVisibleProducts = visible_products.map((product: VisibleProducts) => ({
            value: product.product_id,
            label: product.product_name,
            ...product
        }))
        state.business_area = business_area
        state.corporation = corporation
        state.top_dept = top_dept
        state.product_type_tree = product_type_tree
        state.product_type = product_type
        state.product_sub_type = product_sub_type
        state.software_list = software_list
        state.version_type = version_type
        state.operate_records = operate_records
        state.channel = channel
        state.area = area
        state.preparation_status = preparation_status
        state.privacy_policy_status = privacy_policy_status
        state.privacy_policy_sync_way = privacy_policy_sync_way
        state.privacy_policy_text_type = privacy_policy_text_type
        state.visible_products = formattedVisibleProducts
    },
    setVersion: (state: State, payload: any) => {
        state.version = payload
    }
}

const actions = {
    async getEnums(context: ActionContext<State, any>) {
        const data = await commonService.getEnum()
        if (data.code) throw new Error("未登录")
        context.commit("setEnums", data)
    },
    async getVersion(context: ActionContext<State, any>) {
        const data = await commonService.getVersion()
        if (data.code) throw new Error("未登录")
        context.commit("setVersion", data)
    }
}

const getters = {
    business_area: (state: State) => state.business_area,
    corporation: (state: State) => state.corporation,
    software_list: (state: State) => state.software_list,
    product_type_tree: (state: State) => state.product_type_tree,
    product_type: (state: State) => state.product_type,
    productTypeMap: (state: State) =>
        state.product_type.reduce((map, cur) => {
            map[cur.value] = cur.label
            return map
        }, {} as Record<string, string>),
    product_sub_type: (state: State) => state.product_sub_type,
    productSubTypeMap: (state: State) =>
        state.product_sub_type.reduce((map, cur) => {
            map[cur.value] = cur.label
            return map
        }, {} as Record<string, string>),
    top_dept: (state: State) => state.top_dept,
    version_type: (state: State) => state.version_type,
    operate_records: (state: State) => state.operate_records,
    channel: (state: State) => state.channel,
    area: (state: State) => state.area,
    areaMap: (state: State) => arr2map(state.area, "value", "label", "child"),
    preparation_status: (state: State) => state.preparation_status,
    preparationStatusMap: (state: State) =>
        arr2map(state.preparation_status, "value", "label", "child"),
    privacy_policy_status: (state: State) => state.privacy_policy_status,
    PolicyStatusMap: (state: State) =>
        arr2map(state.privacy_policy_status, "value", "label", "child"),
    privacy_policy_sync_way: (state: State) => state.privacy_policy_sync_way,
    syncWayMap: (state: State) => arr2map(state.privacy_policy_sync_way, "value", "label", "child"),
    privacy_policy_text_type: (state: State) => state.privacy_policy_text_type,
    textTypeMap: (state: State) =>
        arr2map(state.privacy_policy_text_type, "value", "label", "child"),
    visible_products: (state: State) => state.visible_products
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
